Fancybox.bind("[data-fancybox]", {
  // Your custom options
});

document.addEventListener("DOMContentLoaded", function () {
  /* burger menu */
  const burger = document.querySelector(".burger");
  if (burger) {
    const headerMobile = document.querySelector(".header__bottom");
    const header = document.querySelector(".header");
    burger.addEventListener("click", () => {
      headerMobile.classList.toggle("active");
      burger.classList.toggle("active");
      header.classList.toggle("active");
      if (burger.classList.contains("active")) {
        scrollWidthFunc();
      } else {
        document.querySelector("html").style.paddingRight = "0px";
        document.querySelector("header").style.paddingRight = "0px";
      }
      document.querySelector("html").classList.toggle("burger-lock");
    });
  }
  /* end burger menu */

  // dropdown menu
  const menuBtns = document.querySelectorAll("button.header__nav-open");

  if (menuBtns.length > 0) {
    menuBtns.forEach(function (menuBtn) {
      menuBtn.addEventListener("click", function () {
        if (window.innerWidth > 1024) {
          menuBtns.forEach((el) => {
            if (el != this) {
              el.classList.remove("active");
            }
          });
          menuBtn.classList.toggle("active");
        }
      });
      window.addEventListener("click", function (e) {
        if (window.innerWidth > 1024) {
          const target = e.target;
          if (!target.closest(".header__nav-open")) {
            menuBtn.classList.remove("active");
          }
        }
      });
    });
  }

  const navButtons = document.querySelectorAll(".header__nav-open");

  // Функция пересчёта полной высоты (с учётом вложенных списков)
  function getFullHeight(element) {
    let clone = element.cloneNode(true);
    clone.style.maxHeight = "none";
    clone.style.height = "auto";
    clone.style.opacity = "0";
    clone.style.position = "absolute";
    clone.style.pointerEvents = "none";
    document.body.appendChild(clone);
    let height = clone.scrollHeight;
    document.body.removeChild(clone);
    return height;
  }

  // Первый уровень аккордеона
  navButtons.forEach((btn) => {
    const sublist = btn.querySelector(".header__nav-sublist");

    btn.addEventListener("click", (e) => {
      if (window.innerWidth >= 1024) return;

      if (e.target.closest(".header__nav-arrow")) return;
      if (sublist.contains(e.target)) return;

      btn.classList.toggle("active");

      if (btn.classList.contains("active")) {
        sublist.style.maxHeight = getFullHeight(sublist) + "px";
      } else {
        sublist.style.maxHeight = null;
      }
    });

    // Второй уровень аккордеона
    const arrows = sublist.querySelectorAll(".header__nav-arrow");
    arrows.forEach((arrow) => {
      const link = arrow.previousElementSibling;
      const subsublist = arrow.nextElementSibling;

      arrow.addEventListener("click", (e) => {
        e.stopPropagation();
        arrow.classList.toggle("active");
        link.classList.toggle("active");

        if (arrow.classList.contains("active")) {
          subsublist.style.maxHeight = subsublist.scrollHeight + "px";
        } else {
          subsublist.style.maxHeight = null;
        }

        // пересчитать высоту родителя с учётом всех элементов
        sublist.style.maxHeight = getFullHeight(sublist) + "px";
      });
    });
  });

  // end mobile menu

  // Popups
  function popupClose(popupActive) {
    popupActive.classList.remove("open");
    setTimeout(() => {
      if (!popupActive.classList.contains("open")) {
        popupActive.classList.remove("active");
      }
    }, 400);
    document.body.classList.remove("lock");
    document.querySelector("html").style.paddingRight = 0;
    document.querySelector("html").classList.remove("lock");
    document.querySelector("header").removeAttribute("style");
  }
  const popupOpenBtns = document.querySelectorAll(".popup-btn");
  const popups = document.querySelectorAll(".popup");
  const originalTitlePopup2 =
    document.querySelector(".original-title").innerHTML;
  const closePopupBtns = document.querySelectorAll(".close-popup-btn");
  closePopupBtns.forEach(function (el) {
    el.addEventListener("click", function (e) {
      popupClose(e.target.closest(".popup"));
    });
  });
  popupOpenBtns.forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      const path = e.currentTarget.dataset.path;
      const currentPopup = document.querySelector(`[data-target="${path}"]`);
      if (currentPopup) {
        popups.forEach(function (popup) {
          popupClose(popup);
          popup.addEventListener("click", function (e) {
            if (!e.target.closest(".popup__content")) {
              popupClose(e.target.closest(".popup"));
            }
          });
        });
        currentPopup.classList.add("active");
        setTimeout(() => {
          currentPopup.classList.add("open");
        }, 10);
        if (currentPopup.getAttribute("data-target") == "popup-change") {
          let originaTitle = currentPopup.querySelector(".original-title");
          if (el.classList.contains("change-item__btn")) {
            if (el.classList.contains("doctor__btn-js")) {
              let currentItem = el.closest(".change-item");
              let currentTitile = currentItem.querySelector(
                ".change-item__title"
              );
              originaTitle.innerHTML =
                "Записаться на приём к врачу: " + currentTitile.innerHTML;
            } else {
              if (el.classList.contains("change-item__btn_current")) {
                originaTitle.textContent = el.textContent;
              } else {
                let currentItem = el.closest(".change-item");
                let currentTitile = currentItem.querySelector(
                  ".change-item__title"
                );
                originaTitle.innerHTML = currentTitile.innerHTML;
              }
            }
          } else {
            originaTitle.innerHTML = originalTitlePopup2;
          }
        }

        if (currentPopup.getAttribute("data-target") == "popup-jobs") {
          let currentItems = el.closest(".jobs__items");
          let originalText = currentPopup.querySelector(
            ".jobs__inner_original"
          );
          if (originalText && currentItems.querySelector(".jobs__inner")) {
            originalText.innerHTML =
              currentItems.querySelector(".jobs__inner").innerHTML;
          }
        }
        e.stopPropagation();
        scrollWidthFunc();
        document.querySelector("html").classList.add("lock");
      }
    });
  });
  // end popups
  // close cookie
  const cookieBtn = document.querySelector(".popup-cookie__btn");
  if (cookieBtn) {
    cookieBtn.addEventListener("click", () => {
      document.querySelector(".popup-cookie").style.display = "none";
    });
  }

  /*  search */
  const inputSearch = document.querySelectorAll("input[type=search]");
  if (inputSearch.length > 0) {
    inputSearch.forEach((elem) => {
      const wrapper = elem.closest(".search-wrapper");
      if (wrapper) {
        const searchResultBlock = wrapper.querySelector(
          ".popup__search-result"
        );
        const popularCitiesBlock = wrapper.querySelector(".popup__search");
        const noResultsMessage = searchResultBlock.querySelector(
          ".no-results-message"
        );

        function search() {
          let filter = elem.value.toUpperCase();
          let ul = wrapper.querySelectorAll(".search-list");
          let totalResults = 0;

          ul.forEach((item) => {
            let li = item.getElementsByTagName("li");
            for (let i = 0; i < li.length; i++) {
              let a = li[i].querySelector(".search-name");
              if (a.innerHTML.toUpperCase().indexOf(filter) > -1) {
                li[i].classList.remove("none");
                totalResults++;
              } else {
                li[i].classList.add("none");
              }
            }
          });
          noResultsMessage.classList.toggle("none", totalResults > 0);

          if (elem.value.trim() === "") {
            searchResultBlock.classList.add("none");
            popularCitiesBlock.classList.remove("none");
          } else {
            searchResultBlock.classList.remove("none");
            popularCitiesBlock.classList.add("none");
          }
        }
        elem.addEventListener("input", search);

        document.addEventListener("click", (event) => {
          if (!wrapper.contains(event.target)) {
            searchResultBlock.classList.add("none");
          }
        });
      }
    });
  }
  /*  end search  */
  /* search in page */
  const searchInput = document.getElementById("searchInput");
  if (searchInput) {
    searchInput.addEventListener("input", function () {
      const searchValue = this.value.toLowerCase();
      const rows = document.querySelectorAll(".search-page-item");

      rows.forEach(function (row) {
        const serviceName = row
          .querySelector(".search-page-name")
          .textContent.toLowerCase();

        if (serviceName.includes(searchValue)) {
          row.style.display = "";
        } else {
          row.style.display = "none";
        }
      });
      quantityElem();
      checkAndHideBlocksIfEmpty();
    });
  }

  /*  btn more  */
  /* navigation */

  const articleNavigation = document.querySelector(".navigation");
  if (articleNavigation) {
    const jsScrollBlockList = document.querySelectorAll(
      ".text-block h1, .text-block h2, .text-block h3, .text-block h4"
    );

    if (jsScrollBlockList.length > 0) {
      for (let i = 0; i < jsScrollBlockList.length; i += 1) {
        const jsScrollBlock = jsScrollBlockList[i];
        const titleBlock = jsScrollBlock.textContent;
        const articleNavigationList =
          document.querySelector(".navigation__list");
        const articleNavigationItem = document.createElement("li");
        const articleNavigationLink = document.createElement("a");
        if (jsScrollBlock.tagName == "H1") {
          articleNavigationItem.classList.add("nav-title-h1");
        }
        articleNavigationItem.classList.add("navigation__item");
        if (jsScrollBlock.tagName == "H2") {
          articleNavigationItem.classList.add("nav-title-h2");
        } else if (jsScrollBlock.tagName == "H3") {
          articleNavigationItem.classList.add("nav-title-h3");
        } else if (jsScrollBlock.tagName == "H4") {
          articleNavigationItem.classList.add("nav-title-h4");
        } else if (jsScrollBlock.tagName == "H5") {
          articleNavigationItem.classList.add("nav-title-h5");
        } else if (jsScrollBlock.tagName == "H6") {
          articleNavigationItem.classList.add("nav-title-h6");
        }
        articleNavigationLink.classList.add("navigation__link");
        jsScrollBlock.setAttribute("id", `${i}`);
        articleNavigationLink.setAttribute("href", `$${i}`);
        articleNavigationLink.textContent = " " + titleBlock;
        articleNavigationItem.append(articleNavigationLink);
        articleNavigationList.append(articleNavigationItem);
      }
      document.querySelectorAll('a[href^="$"').forEach((link) => {
        link.addEventListener("click", function (e) {
          e.preventDefault();
          let href = this.getAttribute("href").substring(1);
          const scrollTarget = document.getElementById(href);
          const topOffset = 100;
          const elementPosition = scrollTarget.getBoundingClientRect().top;
          const offsetPosition = elementPosition - topOffset;
          window.scrollBy({
            top: offsetPosition,
            behavior: "smooth",
          });
        });
      });
    } else {
      if (articleNavigation.querySelector(".navigation")) {
        articleNavigation.querySelector(".navigation").remove();
      }
    }
  }
  /* end navigation */
});

const tabButtons = document.querySelectorAll(".tab-btn");
const tabContents = document.querySelectorAll(".tab-content");
const containerBtns = document.querySelector(".tab-btns");

if (tabButtons.length > 0 && tabContents.length > 0) {
  tabButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const target = btn.dataset.tab;
      console.log(target + "== all");
      if (btn.classList.contains("active")) {
        tabButtons.forEach((b) => b.classList.remove("active"));
      } else {
        tabButtons.forEach((b) => b.classList.add("active"));
      }
      tabButtons.forEach((b) => b.classList.remove("active"));

      btn.classList.add("active");

      tabContents.forEach((content) => {
        if (content.dataset.tab == target) {
          content.classList.add("active");
        } else {
          content.classList.remove("active");
        }
        if (target == "all") {
          content.classList.add("active");
        }
      });
    });
  });
}

const reviewsBtn = document.querySelectorAll(".read-more__btn");
if (reviewsBtn.length > 0) {
  reviewsBtn.forEach((btn) => {
    btn.addEventListener("click", () => {
      const reviewsTextWrap = btn.closest(".read-more");
      reviewsTextWrap.classList.toggle("open");
      if (reviewsTextWrap.classList.contains("open")) {
        btn.textContent = "Скрыть";
      } else {
        btn.textContent = "Читать дальше";
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initPagination();
  const selectServices = document.querySelector(".selection");
  const servicesBtns = document.querySelector(".selection__btns");
  const servicesItems = document.querySelector(".selection__items");
  const servicesBtn = document.querySelector(".selection__btn");
  const servicesItem = document.querySelectorAll(".selection__item");
  if (
    selectServices &&
    servicesBtns &&
    servicesItem.length > 0 &&
    servicesBtn &&
    servicesItems
  ) {
    servicesBtns.addEventListener("click", () => {
      selectServices.classList.toggle("open");
    });
    servicesItem.forEach((btn) => {
      btn.addEventListener("click", () => {
        const btnText = btn.textContent.trim();
        const btnAttribute = btn.getAttribute("data-tab");

        const selectText = servicesBtn.textContent.trim();
        const selecAttribute = servicesBtn.getAttribute("data-tab");

        btn.textContent = selectText;
        btn.setAttribute("data-tab", selecAttribute);

        servicesBtn.textContent = btnText;
        servicesBtn.setAttribute("data-tab", btnAttribute);

        const selecAttributeNew = servicesBtn.getAttribute("data-tab");
        if (
          selecAttributeNew != "all" &&
          btn.getAttribute("data-tab") == "all"
        ) {
          servicesItems.insertBefore(btn, servicesItems.firstChild);
        }

        initSelect(selecAttributeNew);
        initPagination();
        pagesBtns();
        countReviews();
      });
    });
    document.addEventListener("click", (e) => {
      if (!selectServices.contains(e.target)) {
        selectServices.classList.remove("open");
      }
    });
  }
  countReviews();
  function countReviews() {
    const reviewsItem = document.querySelectorAll(".reviews__item");
    const reviewsNum = document.querySelector(".reviews__counts-num");
    let countReviews = 0;
    if (reviewsItem.length > 0 && reviewsNum) {
      reviewsItem.forEach((elem) => {
        if (!elem.classList.contains("hidden")) {
          countReviews++;
        }
      });
      reviewsNum.textContent = countReviews;
    }
  }

  function initSelect(getAttribute) {
    const pagesItems = document.querySelectorAll(".pages__item");

    if (pagesItems.length > 0) {
      pagesItems.forEach((item) => item.classList.add("hidden"));
      pagesItems.forEach((item) => {
        if (item.getAttribute("data-tab") == getAttribute) {
          item.classList.remove("hidden");
        }
        if (getAttribute == "all") {
          pagesItems.forEach((item) => item.classList.remove("hidden"));
        }
      });
    }
  }

  function initPagination() {
    const pagesItems = document.querySelectorAll(".pages__item");
    const pagesBtnsWrap = document.querySelector(".pages__btns-wrap");
    const faqItems = document.querySelector(".faq__items");
    let elementPage = 12;
    if (faqItems) {
      elementPage = 10;
    }

    if (!pagesBtnsWrap || pagesItems.length === 0) return;

    let pageTag = 1;
    let visibleCount = 0;
    let openedCount = 0;

    pagesItems.forEach((item) => item.classList.remove("open"));
    pagesItems.forEach((element) => {
      if (element.classList.contains("hidden")) return;
      if (openedCount < elementPage) {
        element.classList.add("open");
        openedCount++;
      }
      element.setAttribute("data-page", "rev-" + pageTag);
      visibleCount++;

      if (visibleCount === elementPage) {
        pageTag++;
        visibleCount = 0;
      }
    });

    const totalPages = visibleCount === 0 ? pageTag - 1 : pageTag;
    pagesBtnsWrap.innerHTML = "";
    for (let i = 1; i <= totalPages; i++) {
      const btn = document.createElement("button");
      btn.classList.add("pages__btn");
      btn.textContent = i;
      btn.setAttribute("data-page", "rev-" + i);
      if (i === 1) {
        btn.classList.add("active");
      }
      pagesBtnsWrap.appendChild(btn);
    }
  }
  function pagesBtns() {
    const pagesBtns = document.querySelectorAll(".pages__btn");
    const pagesItems = document.querySelectorAll(".pages__item");

    if (!pagesBtns.length || !pagesItems.length) return;

    function updateView(activeIndex) {
      const total = pagesBtns.length;

      pagesBtns.forEach((btn) => btn.classList.remove("active", "view"));
      document.querySelectorAll(".pages__ellipsis").forEach((e) => e.remove());

      pagesBtns[activeIndex].classList.add("active");

      pagesBtns[0].classList.add("view");
      pagesBtns[total - 1].classList.add("view");

      if (activeIndex === 0) {
        if (pagesBtns[1]) pagesBtns[1].classList.add("view");
        if (pagesBtns[2]) pagesBtns[2].classList.add("view");
      } else if (activeIndex === total - 1) {
        if (pagesBtns[total - 2]) pagesBtns[total - 2].classList.add("view");
        if (pagesBtns[total - 3]) pagesBtns[total - 3].classList.add("view");
      } else {
        if (pagesBtns[activeIndex - 1])
          pagesBtns[activeIndex - 1].classList.add("view");
        if (pagesBtns[activeIndex + 1])
          pagesBtns[activeIndex + 1].classList.add("view");
      }

      pagesItems.forEach((item) => {
        item.classList.toggle(
          "open",
          pagesBtns[activeIndex].getAttribute("data-page") ===
            item.getAttribute("data-page")
        );
      });

      if (activeIndex > 2) {
        const ellipsisBefore = document.createElement("span");
        ellipsisBefore.textContent = "...";
        ellipsisBefore.classList.add("pages__ellipsis");
        pagesBtns[0].after(ellipsisBefore);
      }
      if (activeIndex < total - 3) {
        const ellipsisAfter = document.createElement("span");
        ellipsisAfter.textContent = "...";
        ellipsisAfter.classList.add("pages__ellipsis");
        pagesBtns[activeIndex + 1].after(ellipsisAfter);
      }
    }

    updateView(0);

    pagesBtns.forEach((btn, index) => {
      btn.addEventListener("click", () => updateView(index));
    });
  }
  pagesBtns();
});
document.addEventListener("DOMContentLoaded", function () {
  const showElems = document.querySelectorAll(".show__elems");

  if (showElems.length > 0) {
    console.log("sddsdsds");
    showElems.forEach((container) => {
      const faqItem = container.querySelectorAll(".show__elem");

      faqItem.forEach((item) => {
        const btn = item.querySelector(".show__elem-btn");
        if (btn) {
          btn.addEventListener("click", () => {
            if (item.classList.contains("active")) {
              item.classList.remove("active");
            } else {
              // faqItem.forEach((el) => el.classList.remove("active"));
              item.classList.add("active");
            }
          });
        }
      });
    });
  }
});
